import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import {DocumentsService} from "../../services/document.service";
import {CognitoService} from "../../services/cognito.service";
import Swal from "sweetalert2";
declare var $: any;

@Component({
  selector: 'app-trainer-dashboard',
  templateUrl: './trainer-dashboard.component.html',
  styleUrl: './trainer-dashboard.component.css'
})
export class TrainerDashboardComponent implements OnInit{
  dataUser    : any;
  isLoggedIn$: any;
  userLogged: boolean;
  userInfo: any;
  placeId: string;
  rolId: any;
  rolName: any;

  constructor(private auth: AuthService,
              private utilsService: UtilsService,
              private documentService: DocumentsService,
              private cognitoService: CognitoService
  ) {}

  ngOnInit(): void {
    $('#sidebar-overlay').click();
    // debugger
    // this.isLoggedIn$ = this.auth.isLoggedIn;
    // this.userLogged = false;
    // if(this.isLoggedIn$.source._value){
    //   this.userLogged = true;
    // }

    this.userInfo = this.utilsService.getStorage('userData');

    // this.createAlimentoFn()
    // console.log(this.userInfo)
  }

  addProgresoCliente(){
    let objeto: any = {}
    let attchId = "6142E157-8B92-4333-8FE2-CE66259047AD" //this.utilsService.create_UUID()

    objeto = {
      "attachmentId": attchId,
      "documentId": "fatimajatziris+client3@gmail.comCliente",
      "fecha": "01-01-2025",
      "timestamp": 1735732800,
      "peso": 100,
      "circunferenciaAbdominal": 80,
      "cadera": 80,
      "comentarios": "Estos son comentarios del cliente del cuarto registro de progreso. Estos son comentarios del cliente del cuarto registro de progreso. Estos son comentarios del cliente del cuarto registro de progreso. Estos son comentarios del cliente del cuarto registro de progreso. Estos son comentarios del cliente del cuarto registro de progreso.",
      "fotoFrente": "https://media.istockphoto.com/id/513727339/es/foto/cabeza-y-hombros-hombre-s-silhouette.jpg?s=612x612&w=0&k=20&c=TSTW212EEofOv0DgMmLaKKOFtnsqLuf0XxVQzAsSSKE=",
      "fotoLado": "https://st4.depositphotos.com/2618131/38354/i/450/depositphotos_383548604-stock-photo-photo-of-mans-isolated-silhouette.jpg",
      "origen": "Progreso",
      "edad": 30,
      "altura": 180
    }

    // this.documentService.updateDocumentAttachment(
    //     environment.businessId,
    //     "fatimajatziris+client3@gmail.comCliente",
    //     attchId,
    //     'progresoCliente',
    //     null,
    //     objeto
    // ).subscribe({
    //   next: (response: any) => {
    //     // this.entrenadores.push(response);
    //     Swal.fire({
    //       title: "Ejercicio Regostrado",
    //       text: "Ejercicio registrado.",
    //       icon: "success",
    //     })
    //   },
    //   error: (error) => {
    //     console.log(error);
    //   },
    //   complete: () => {
    //     console.log('complete')
    //   }
    // })

    // this.documentService.createDocumentAttachment(
    //     environment.businessId,
    //     "fatimajatziris+client3@gmail.comCliente",
    //     attchId,
    //     'progresoCliente',
    //     null,
    //     objeto
    // ).subscribe({
    //   next: (response: any) => {
    //     // this.entrenadores.push(response);
    //     Swal.fire({
    //       title: "Progreso Registrado",
    //       text: "Progreso registrado.",
    //       icon: "success",
    //     })
    //   },
    //   error: (error) => {
    //     console.log(error);
    //   },
    //   complete: () => {
    //     console.log('complete')
    //   }
    // })
  }

  addUserAtributes(){
    let objeto: any = {}
    let objetoEntrenador: any = {}
    let attchId = this.utilsService.create_UUID()

    objetoEntrenador = {
      "attachmentId": attchId,
      "documentId": "fatimajatziris+client3@gmail.comCliente",
      "fecha": "10-02-2025",
      "timestamp": 1739196000,
      "detalleEjercicio": {
        "documentContainerId": "180fitnessbsd@gmail.com",
        "documentId": "0f5d773e-c8df-43c2-8a8c-50859891e9d4",
        "documentType": "ejercicio",
        "businessId": "180-fitness-dev",
        "activo": true,
        "nombre1": "Abdomen",
        "nombre2": "",
        "tipo": "",
        "nivel": "",
        "mecanica": "",
        "equipo": "",
        "musculo": "",
        "otros": [],
        "posicionInicial": "Completamente recto con las piernas abajo",
        "descripcion": "",
        "notas": "",
        "linkVideo": "https://youtu.be/",
        "linksAdicionales": [],
        "propietario": "180fitnessbsd@gmail.com",
        "empresaId": "919cd10a-48ff-4d3f-83e7-d0cba8547d0d",
        "tags": [
          "Cu\u00e1driceps",
          "B\u00edceps",
          "Antebrazo",
          "Otro"
        ],
        "imagenPosicionInicial": {
          "nombre": "Abdoben1.png",
          "url": "https://vf94bs16l0.execute-api.us-west-2.amazonaws.com/prod/images/180-fitness-dev_B6B84712-54E6-4439-B190-759BDC98E868.webp"
        },
        "imagenPosicionFinal": {
          "nombre": "Abdomen2.png",
          "url": "https://vf94bs16l0.execute-api.us-west-2.amazonaws.com/prod/images/180-fitness-dev_60099AE4-E177-426F-A83F-2B895EB643EB.webp"
        },
        "esDocumentId": "0f5d773e-c8df-43c2-8a8c-50859891e9d4",
        "esDocumentType": "ejercicio",
        "esDocumentDate": "2025-01-30T15:01:08.258000Z",
        "esDocumentYear": "2025",
        "esDocumentMonth": "01",
        "esDocumentDay": "30"
      },
      "instrucciones": "",
      "comentariosCliente": "",
      "registroEntrnador": true,
      "comentariosEntrenador": "Estos son comentarios realizados por un entrenador al revisar el registro de ejercicios de un cliente.",
      "series": []
    }

    objeto = {
      "attachmentId": attchId,
      "documentId": "fatimajatziris+client3@gmail.comCliente",
      "ejercicioId": "0f5d773e-c8df-43c2-8a8c-50859891e9d4",
      "fecha": "05-02-2025",
      "timestamp": 1738756800,
      "detalleEjercicio": {
        "documentContainerId": "180fitnessbsd@gmail.com",
        "documentId": "0f5d773e-c8df-43c2-8a8c-50859891e9d4",
        "documentType": "ejercicio",
        "businessId": "180-fitness-dev",
        "activo": true,
        "nombre1": "Abdomen",
        "nombre2": "",
        "tipo": "",
        "nivel": "",
        "mecanica": "",
        "equipo": "",
        "musculo": "",
        "otros": [],
        "posicionInicial": "Completamente recto con las piernas abajo",
        "descripcion": "",
        "notas": "",
        "linkVideo": "https://youtu.be/",
        "linksAdicionales": [],
        "propietario": "180fitnessbsd@gmail.com",
        "empresaId": "919cd10a-48ff-4d3f-83e7-d0cba8547d0d",
        "tags": [
          "Cu\u00e1driceps",
          "B\u00edceps",
          "Antebrazo",
          "Otro"
        ],
        "imagenPosicionInicial": {
          "nombre": "Abdoben1.png",
          "url": "https://vf94bs16l0.execute-api.us-west-2.amazonaws.com/prod/images/180-fitness-dev_B6B84712-54E6-4439-B190-759BDC98E868.webp"
        },
        "imagenPosicionFinal": {
          "nombre": "Abdomen2.png",
          "url": "https://vf94bs16l0.execute-api.us-west-2.amazonaws.com/prod/images/180-fitness-dev_60099AE4-E177-426F-A83F-2B895EB643EB.webp"
        },
        "esDocumentId": "0f5d773e-c8df-43c2-8a8c-50859891e9d4",
        "esDocumentType": "ejercicio",
        "esDocumentDate": "2025-01-30T15:01:08.258000Z",
        "esDocumentYear": "2025",
        "esDocumentMonth": "01",
        "esDocumentDay": "30"
      },
      "instrucciones": "De 8 a 10 reps c/serie",
      "comentariosCliente": "Estos son los comentarios del cliente",
      "comentariosEntrenador": "Estos son los comentarios del Entrenador. Estos son los comentarios del Entrenador. Estos son los comentarios del Entrenador ",
      "series": [
        {
          "serie": 1,
          "repeticiones": 10,
          "peso": 20
        },
        {
          "serie": 2,
          "repeticiones": 11,
          "peso": 21
        },
        {
          "serie": 3,
          "repeticiones": 12,
          "peso": 22
        },
        {
          "serie": 4,
          "repeticiones": 13,
          "peso": 23
        }
      ]
    }


    // this.documentService.updateDocumentAttachment(
    //     environment.businessId,
    //     "fatimajatziris+client3@gmail.comCliente",
    //     "ACBEAF07-D359-416D-AB86-76B389C952D2",
    //     'ejercicioCliente',
    //     null,
    //     objetoEntrenador
    // ).subscribe({
    //   next: (response: any) => {
    //     // this.entrenadores.push(response);
    //     Swal.fire({
    //       title: "Ejercicio Regostrado",
    //       text: "Ejercicio registrado.",
    //       icon: "success",
    //     })
    //   },
    //   error: (error) => {
    //     console.log(error);
    //   },
    //   complete: () => {
    //     console.log('complete')
    //   }
    // })


    // this.documentService.createDocumentAttachment(
    //     environment.businessId,
    //     "fatimajatziris+client3@gmail.comCliente",
    //     attchId,
    //     'ejercicioCliente',
    //     null,
    //     objeto
    // ).subscribe({
    //   next: (response: any) => {
    //     // this.entrenadores.push(response);
    //     Swal.fire({
    //       title: "Ejercicio Regostrado",
    //       text: "Ejercicio registrado.",
    //       icon: "success",
    //     })
    //   },
    //   error: (error) => {
    //     console.log(error);
    //   },
    //   complete: () => {
    //     console.log('complete')
    //   }
    // })

  }

  registraAlimentosDia(){
    let obj: any = {}
    let attchId = this.utilsService.create_UUID()
    obj = {
      "attachmentId": attchId,//uuid
      "programaId": "5eecbc82-7b84-418d-a9d5-95623bcb38ae",
      "documentId": "mart@gssss.comCliente",
      "dia": 35,
      "fecha": "06-04-2025",
      "periodo": 2,
      "alimentosDesayuno": [],
      "alimentosSnack1": [],
      "alimentosComida": [],
      "alimentosSnack2": [],
      "alimentosCena": [],
      "suplementos": []
    }

    // this.documentService.createDocumentAttachment(
    //     environment.businessId,
    //     "mart@gssss.comCliente",
    //     attchId,
    //     'alimentosDiaCliente',
    //     null,
    //     obj
    // ).subscribe({
    //   next: (response: any) => {
    //     // this.entrenadores.push(response);
    //     Swal.fire({
    //       title: "Ejercicio Regostrado",
    //       text: "Ejercicio registrado.",
    //       icon: "success",
    //     })
    //   },
    //   error: (error) => {
    //     console.log(error);
    //   },
    //   complete: () => {
    //     console.log('complete')
    //   }
    // })

  }

}
